import type { PropertiesNearbyVariant } from './resolvePropertiesNearbyVariant'

interface ShouldShowPropertiesNearbyArgs {
  variant: PropertiesNearbyVariant | null
  isExpandedSearch: boolean
  expandedPropertiesCount: number
}

export const shouldShowPropertiesNearby = ({
  variant,
  isExpandedSearch,
  expandedPropertiesCount,
}: ShouldShowPropertiesNearbyArgs): boolean =>
  variant === 'variant_a' && !isExpandedSearch && expandedPropertiesCount > 0
